import type { FeatureState } from '@tfa/shared'

/**
 * #569: звать подключать FatSecret можно только там, где тариф его даёт.
 * На Программе синхронизация «серая» (видна, но недоступна) — подсказка
 * «Подключи FatSecret» и кнопка «Подключить» там обещали то, чего нет.
 * Уже подключённому звать некуда в любом случае.
 */
export function canOfferFatSecretConnect(connected: boolean, state: FeatureState): boolean {
  return !connected && state === 'open'
}
